import React from 'react';
import CircleFlag from '../CircleFlag/CircleFlag';
import './CountryPrefix.scss';
import Icon, { Icons } from '../../../Icon/Icon';

const CountryPrefix = ({ country, onClick }) => {
	return (
		<div className='CountryPrefix' onClick={onClick}>
			<CircleFlag countryCode={country.iso} height={24} />
			<div className='CountryPrefix-btn'>
				<div className='CountryPrefix__code'>{country.code}</div>
				<div className='CountryPrefix__arrow'></div>
				<Icon
					className='CountryPrefix__arrow'
					type={Icons.ARROW_DROP_DOWN}
					width={24}
					height={24}
				/>
			</div>
		</div>
	);
};

export default CountryPrefix;
